import { render, staticRenderFns } from "./InterrogatoryModal.vue?vue&type=template&id=ec2eb464&scoped=true&"
import script from "./InterrogatoryModal.vue?vue&type=script&lang=js&"
export * from "./InterrogatoryModal.vue?vue&type=script&lang=js&"
import style0 from "./InterrogatoryModal.vue?vue&type=style&index=0&id=ec2eb464&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2eb464",
  null
  
)

export default component.exports